import { CurrentSectionSpiIt } from '@ingenico/react-section-utils';
import { deviceManagementContainer } from '../container.const';
import type { DeviceManagementHostInfo, DeviceManagementSpiPort } from '../domain/hexa/ports/spi.model';

// Shells that predate getHostInfo do not declare themselves, so they are treated as a generic host.
const DEFAULT_HOST_INFO: DeviceManagementHostInfo = { kind: 'host' };

export function useDeviceManagementHostInfo(): DeviceManagementHostInfo {
  if (!deviceManagementContainer.isBound(CurrentSectionSpiIt)) {
    return DEFAULT_HOST_INFO;
  }

  return (
    deviceManagementContainer.get<DeviceManagementSpiPort>(CurrentSectionSpiIt).getHostInfo?.() ?? DEFAULT_HOST_INFO
  );
}
